import {useForm} from 'react-hook-form';
import {createRequest} from '../services/api';
import {useDispatch, useSelector} from 'react-redux';
import React from 'react';

interface IProps {
    setLoginStatus: (status: string) => void,
    message: string
}

export const AccessRequest = (props: IProps) => {
    const dispatch = useDispatch();
    const {setLoginStatus, message} = props;
    const [msg, setMsg] = React.useState<string>(message);
    const [loading, setLoading] = React.useState<boolean>(false);
    const firstName = useSelector((state: any) => state.questionReducer.firstName);
    const profilePath = useSelector((state: any) => state.questionReducer.profilePath);

    const {
        register,
        handleSubmit,
        formState: {errors},
    } = useForm();
    const submitForm = async (data: any) => {
        let params = data;
        params.profile_path = profilePath;
        setLoading(true);
        const result = await createRequest(params);
        let message = "Thank you for your interest in Touchcast. Our team will get you approved to access " + firstName + "'s Synth. Please expect an email once you are granted access";
        if (result.data && result.data.success === true) {
            if (result.data.message) {
                message = result.data.message;
            }
            setMsg(message);
        }
        setLoading(false);
    }

    return (
        <div className={`di-profile-upload-wrapper di-box-style ${msg != '' ? 'tc-login-small' : ''}`}>
            {msg != '' ?
                <div className="di-profile-upload-container">
                    <h4>{msg}</h4>
                    <input className="di-btn company-btn submit-btn"
                           value={"Back To Login"} onClick={() => {
                        setMsg('');
                        setLoginStatus('login');
                    }}/>
                </div> :
                <div className="di-profile-upload-container">
                    <h2>{firstName}'s Synth Access Request</h2>
                    <form onSubmit={handleSubmit((data) => submitForm(data))}>
                        <div className="di-form-field-wrapper">
                            <div className="di-form-field-item">
                                <p>First name</p>
                                <input type="text" {...register('first_name', {required: true})} required
                                       name="first_name"
                                       className={`company-field ${errors.fullName ? 'error-input' : ''}`}
                                       placeholder="First name"/>
                            </div>
                            <div className="di-form-field-item">
                                <p>Last name</p>
                                <input type="text" {...register('last_name', {required: true})} required
                                       name="last_name"
                                       className={`company-field ${errors.fullName ? 'error-input' : ''}`}
                                       placeholder="Last name"/>
                            </div>
                        </div>
                        <div className="di-form-field-wrapper">
                            <div className="di-form-field-item">
                                <p>Compay</p>
                                <input type="text" {...register('company', {required: true})} required name="company"
                                       className={`company-field ${errors.fullName ? 'error-input' : ''}`}
                                       placeholder="Company"/>
                            </div>
                            <div className="di-form-field-item">
                                <p>Role</p>
                                <input type="text" {...register('role', {required: true})} required name="role"
                                       className={`company-field ${errors.fullName ? 'error-input' : ''}`}
                                       placeholder="Role"/>
                            </div>
                        </div>

                        <div className="di-form-field-wrapper">
                            <div className="di-form-field-item">
                                <p>Email</p>
                                <input type="email" {...register('email', {required: true})} required name="email"
                                       className={`company-field ${errors.fullName ? 'error-input' : ''}`}
                                       placeholder="Email"/>
                            </div>
                        </div>

                        <input disabled={loading} type='submit' className="di-btn company-btn submit-btn"
                               value={"Submit"}/>
                    </form>
                </div>}
        </div>
    )
}
